export const formatBadgeCount = (count = 0): number | string | null => {
  if (count <= 0) return null;
  if (count < 100) return count;
  return '+99';
};
